import React, { Component } from "react";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { setCategory, getCategoryBySlug } from "../../store/actions/category";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";
import { orderEnquiry } from "../../store/actions/order";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../components/shared/Loading";
import styles from "../../thema/style";
import OrderDetailInfo from "../../components/OrderDetailInfo";
import OrderDetailAdress from "../../components/OrderDetailAdress";
import OrderDetailProducts from "../../components/OrderDetailProducts";
import OrderDetailInfoDetail from "../../components/OrderDetailInfoDetail";
import OrderDetailHistory from "../../components/OrderDetailHistory";

class OrderEnquiry extends Component {
  state = { id: null };
  componentDidMount() {
    // console.log("-------", this.props.match.params.id);
    this.setState(
      {
        id: this.props.match.params.id,
      },
      () => {
        window.scrollTo(0, 0);
        if (this.props.match.params.id) {
          this.onSubmit();
        }
      }
    );
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (this.props.match.params.slug !== prevProps.match.params.slug) {
  //     this.setState(
  //       {
  //         page: this.props.page.page.find(
  //           ({ slug }) => slug === this.props.match.params.slug
  //         ),
  //       },
  //       () => {
  //         window.scrollTo(0, 0);
  //       }
  //     );
  //   }
  // }

  onSubmit = (e) => {
    e && e.preventDefault();
    this.props.orderEnquiry(this.state.id);
  };

  renderOrderDetail() {
    const address = this.props.order.orderEnquiry.customer.addresses.find(
      (address) => {
        if (
          this.props.order.orderEnquiry.address.toString() ===
          address.id.toString()
        ) {
          return true;
        } else {
          return address.active === true;
        }
      }
    );

    return (
      <React.Fragment>
        <OrderDetailInfo customer={false} {...this.props} />
        <OrderDetailAdress customer={false} address={address} />

        <OrderDetailProducts
          customer={false}
          products={this.props.order.orderEnquiry.products.map(
            ({ product, quantity, price }) => ({
              ...product,
              quantity,
              salePrice: price,
            })
          )}
          {...this.props}
        />

        <OrderDetailInfoDetail customer={false} {...this.props} />
        <h4 style={{ marginTop: 30 }}>Sipariş Geçmişi</h4>
        <OrderDetailHistory customer={false} {...this.props} />
      </React.Fragment>
    );
  }
  render() {
    console.log(":::xxx", this.props.order.order);
    return (
      <React.Fragment>
        <PageTitle title={"Sipariş Sorgula"} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9"}>
                <div
                  className={"row"}
                  style={{ marginTop: 20, marginBottom: 50 }}
                >
                  <form
                    onSubmit={this.onSubmit}
                    style={{ width: "100%", marginTop: 20 }}
                  >
                    <div className="form-group w-100">
                      <label>Sipariş Numaranızı Giriniz</label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        name={"id"}
                        placeholder="FC-000000"
                        defaultValue={this.state.id}
                        value={this.state.id}
                        onChange={(e) => {
                          this.setState({ id: e.target.value });
                          this.props.history.push(
                            `/siparis-sorgula/${e.target.value}`
                          );
                        }}
                      />
                    </div>

                    <p>FC-XXXXX İle Başlayan sipariş numaranızı Giriniz</p>

                    <button
                      style={{ marginTop: 10 }}
                      type="submit"
                      // disabled={
                      //   this.props.order.fetching ||
                      //   this.props.cart.items.length === 0
                      // }
                      className={styles.buttonDefaultSM}
                    >
                      {this.props.order.fetching ? (
                        <React.Fragment>
                          <FontAwesomeIcon icon="spinner" size={"lg"} spin />{" "}
                          Siparişiniz Sorgulanıyor...
                        </React.Fragment>
                      ) : (
                        "Sipariş Sorgula"
                      )}
                    </button>
                  </form>

                  {this.props.order.orderEnquiry !== false ? (
                    this.props.order.orderEnquiry === null ? (
                      <p>
                        Aradığınız sipariş numarasına ait bir sipariş
                        bulunamadı.
                      </p>
                    ) : (
                      this.renderOrderDetail()
                    )
                  ) : null}
                </div>
              </div>
              <div className={"col-md-3"}>
                <CartWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ order }) => {
  return { order };
};

const mapDispatchToProps = { orderEnquiry };

export default connect(mapStateToProps, mapDispatchToProps)(OrderEnquiry);



// WEBPACK FOOTER //
// ./src/routers/OrderEnquiry /index.js